module.exports = __webpack_public_path__ + "img/output.55e33f9d.jpg";